/**
 * Featured Publications — Swiper with prev/next + mobile dots.
 */

(function () {
    'use strict';

    const SELECTOR = '[data-featured-publications]';
    const SWIPER_SELECTOR = '[data-pubs-swiper]';
    let swiperBundlePromise = null;

    function loadSwiperBundle() {
        if (!swiperBundlePromise) {
            swiperBundlePromise = Promise.all([
                import('swiper'),
                import('swiper/modules'),
            ]).then(([swiperMod, modulesMod]) => ({
                Swiper: swiperMod.default || swiperMod.Swiper,
                Navigation: modulesMod.Navigation,
                Pagination: modulesMod.Pagination,
            }));
        }

        return swiperBundlePromise;
    }

    function prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function initSlider(root, { Swiper, Navigation, Pagination }) {
        const el = root.querySelector(SWIPER_SELECTOR);
        if (!el || el.swiper) {
            return;
        }

        const slides = el.querySelectorAll('.swiper-slide');
        if (slides.length < 2) {
            return;
        }

        const prevEl = root.querySelector('[data-pubs-prev]');
        const nextEl = root.querySelector('[data-pubs-next]');
        const paginationEl = root.querySelector('[data-pubs-pagination]');
        const reduceMotion = prefersReducedMotion();

        root._pubsSwiper = new Swiper(el, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 24,
            speed: reduceMotion ? 0 : 500,
            watchOverflow: true,
            navigation: {
                prevEl,
                nextEl,
            },
            pagination: paginationEl
                ? {
                      el: paginationEl,
                      clickable: true,
                  }
                : undefined,
        });
    }

    async function initFeaturedPublications(container) {
        const root = container || document;
        const blocks = root.querySelectorAll(SELECTOR);

        if (!blocks.length) {
            return;
        }

        try {
            const bundle = await loadSwiperBundle();
            blocks.forEach((block) => initSlider(block, bundle));
        } catch (error) {
            if (window.sojTheme?.debug) {
                // eslint-disable-next-line no-console
                console.warn('Featured Publications: failed to load Swiper', error);
            }
        }
    }

    function onPageReady(e) {
        const container = e?.detail?.container || document;
        if (container.querySelector(SELECTOR)) {
            initFeaturedPublications(container);
        }
    }

    if (document.body?.hasAttribute?.('data-barba')) {
        document.addEventListener('barba:pageReady', onPageReady);
    } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () =>
            onPageReady({ detail: { container: document } })
        );
    } else {
        onPageReady({ detail: { container: document } });
    }
})();
